import React from 'react';
import useIsAppEnabled from '../../../ApplicationSyncContext/useIsAppEnabled';
import useSessionStoreContext from '../../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from '../useAudioServerCommunication';
import useSessionLanguage from '../useSessionLanguage';
import useSpeechRecognition from './useSpeechRecognition';

function createSpeechRecognition() {
  try {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.interimResults = true;
    recognition.maxAlternatives = 1;
    recognition.continuous = true;
    return recognition;
  } catch (err) {
    console.error('SpeechRecognition: An error has occurred creating the speech recognition instance', err);
    return null;
  }
}

export default function useSendAlternativeTranscript(recognitionFactory: () => any = createSpeechRecognition) {
  const sessionLanguage = useSessionLanguage();
  const isAppEnabled = useIsAppEnabled();
  const { sessionId: [sessionId] } = useSessionStoreContext();

  const { sendJsonMessage } = useAudioServerCommunication();

  const effectiveLanguage = React.useMemo(
    () => ((isAppEnabled) ? null : sessionLanguage),
    [isAppEnabled, sessionLanguage],
  );
  useSpeechRecognition(effectiveLanguage, sendJsonMessage, recognitionFactory, sessionId);
}
